








































































import { mapGetters, mapActions } from 'vuex'
import { humanizeIsoDatetime } from 'plankton'
import PageContent from '@/components/PageContent.vue'
import ContactCard from '@/components/ContactCard.vue'
import PaymentDocuments from './PaymentDocuments.vue'
import Card from '@/components/Card.vue'
import ClaimsCard from './ClaimsCard.vue'
import TripOverview from './TripOverview.vue'
import VehicleSpecifications from './VehicleSpecifications.vue'

export default {
  components: {
    Card,
    ClaimsCard,
    PageContent,
    ContactCard,
    TripOverview,
    VehicleSpecifications,
    PaymentDocuments
  },
  props: {
    transportId: { type: String, required: true }
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters([
      'transportOrder',
      'transportRequest',
      'transportMultiStop',
      'currentUser',
      'currentCarrierCompany',
      'contactInfo',
      'ableToUploadPodDocuments',
      'dispatchingConfirmation'
    ]),
    dispatchingConfirmationCreatedOn() {
      return this.dispatchingConfirmation
        ? humanizeIsoDatetime(this.dispatchingConfirmation.orderConfirmation.createdOn)
        : null
    }
  },
  async created() {
    try {
      await Promise.all([
        this.loadTransportDetails(this.transportId),
        this.fetchAbleToUploadPodDocuments(this.transportId),
        this.loadDispatchingConfirmationDetails(this.transportId)
      ])
    } finally {
      this.loading = false
    }
  },
  methods: {
    ...mapActions([
      'loadTransportDetails',
      'fetchAbleToUploadPodDocuments',
      'loadDispatchingConfirmationDetails'
    ])
  }
}
